export class JwtSettingsDTO {
    public accessTokenValidForMinutes?: number;
    public refreshTokenValidForMinutes?: number;

    constructor(obj?) {
        obj = obj || {};

        this.accessTokenValidForMinutes = obj.accessTokenValidForMinutes || null;
        this.refreshTokenValidForMinutes = obj.refreshTokenValidForMinutes || null;
    }
}
